/**
 * @mergeTarget
 * @module Src/Parameters/String/Options
 */
/**
 * Enumerator of options for {@link Src/Parameters/String.LisioStringParameterNames.CURSOR_SIZE} parameter
 * @source
 */
var CursorSizeOptions;
(function (CursorSizeOptions) {
    CursorSizeOptions["BIG"] = "big";
    CursorSizeOptions["VERY_BIG"] = "very_big";
})(CursorSizeOptions || (CursorSizeOptions = {}));
export { CursorSizeOptions };
